import { put, takeEvery, call } from 'redux-saga/effects';
import get from '../../getApiCaller';

const API_DATA = (payload) => {
  const { countryId } = payload;
  return get(
    `audience/filter?countryId=${countryId}&type=brand`,
    'GET',
    true
  ).then((response) => {
    return response;
  });
};

export const GET_CREATE_CAMPAIGN_BRAND_DATA_SAGA =
  function* perform_getCampaignBrandData() {
    yield takeEvery('GET_CREATE_CAMPAIGN_BRAND_DATA', function* (action) {
      yield put({ type: 'GET_CREATE_CAMPAIGN_BRAND_DATA_STARTED' });
      try {
        const DATA = yield call(API_DATA.bind(this, action.payload));
        yield put({
          type: 'GET_CREATE_CAMPAIGN_BRAND_DATA_SUCCESS',
          payload: DATA,
        });
      } catch (error) {
        yield put({
          type: 'GET_CREATE_CAMPAIGN_BRAND_DATA_FAILED',
          payload: error,
        });
      }
    });
  };
